import {ComponentChild} from "preact";

export const CONFIG = {
  wssURL: 'wss://staging.querlo.com:443/chat',
  staticURL: 'https://static.querlo.com/'
};

export type ChatServerMsg = {
  isViewPortMessage: boolean; // used to flag messages like changeBackground which are not physically rendered in viewport
  ls?: boolean; // this is only used by Text messages (in root!) and by Question messages (but in body, so not relevant here)
  merged?: boolean;
  name: string;
  time: string;
  t: number;
  b?: any;
  id: string;
  d?: number;
  u?: number;
  me: boolean;
  avatar2: string;
  avatar1: string;
  spk?: number;
}

export type ChatState = {
  messages: ChatServerMsg[];
  sharerEnabled: boolean;
  lightBoxChild: ComponentChild;
  kickstarted: boolean;
  dynamicStyles: string;
  breadCrumbData: any;
  background: any;
  offline: boolean;
  disconnected: boolean;
};

export const TYPES = {
  CHAT_TXT_MSG: 1,
  CHAT_STICKER_MSG: 2,
  CHAT_IMG_ATTACHMENT: 3,
  REGISTER: 10, //first event, we send a register message to the chat server
  USER_JOINED: 11, //the user is joining a room, used to autojoin global or a user selected room (not supported yet)
  USER_LEFT: 15, //a user left the room
  ROOM_USERS_LIST: 20,
  GLOBAL_DATA: 25,
  USER_IS_MUTED: 30,
  USER_TYPING: 35,
  UI_CHANGE: 38,
  SEND_POLL: 40,
  POLL_ANSWER: 41,
  GRATS: 42,
  CLAIM_GRATS: 43,
  RESET_POLL: 44, //reset poll request, it's more a request to reset the log of a room! used to show/hide the header
  POLL_IMG: 45,
  VIDEO_MSG: 46, //msg with a video embed code
  GOTO: 47,
  SETVARIABLE: 48,
  GENERIC_ERROR: 50,
  PING_REQUEST: 60,
  RECONNECT: 61,
  API_CALL: 62, //request api call from bot
  PING: 65,
  USER_STATE_CHANGED: 70,
  BLOCK_USER: 80,
  UNBLOCK_USER: 81,
  DELETE_MESSAGE: 90,
  MUTE_USER: 91,
  GENERIC_COMMAND: 100,
  PAY_BUTTON: 200, // this is a special message, sent from server as an UI_CHANGE msg but changed by client to a dedicate type
  CMD_CHANGE_BACKGROUND: 210, // this is a special message, sent from server as an UI_CHANGE msg but changed by client to a dedicate type
  CMD_SET_INPUT_UI_STICKY: 211, // this is a special message, sent from server as a GENERIC_COMMAND msg but changed by client to a dedicate type
  CMD_SET_GLOBAL_CFG_ITEM: 212, // this is a special message, sent from server as a GENERIC_COMMAND msg but changed by client to a dedicate type
  CMD_CLEAR_CHAT: 300,
  HUMAN_TAKEOVER: 400,
  SYSTEM_MESSAGE: 1000
};

export enum HTAction {
  HT_START,
  HT_END
}
